module.exports = __webpack_public_path__ + "assets/notification-logo-a22925.png";